module.exports = __webpack_public_path__ + "distribution/img/bei2.59802431.png";